// eslint-disable-next-line import/prefer-default-export
export const centered = '1024px';
